"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'nav.avatar.fallback': 'Awatar',
    'nav.avatar.alt': 'Awatar',
    'nav.avatar.loading': 'Ładowanie Awatara...',
};
